import { doTransition, doWaitImageByTime } from './../helpers/helpers';
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { images } from "./images";
import Game from '../../src/shell/Game';
import { ann } from '../characters/Ann';
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { vanessa } from "../characters/Vanessa";
import { V7JoeGymAfter } from './V7';
import { emily } from '../characters/Emily';
import { othersProfilesPics } from '../helpers/othersInstaPhoneImages';

export const V7JoeGym = async (): Promise<any> => {
    doTransition(images.v7.V7JoeyGym_1);
    mc.think(`There he is.`);
    if (mc.properties.joeStatus === "enemy") {
        return jump(V7JoeGym_Enemy, "V7JoeGym_Enemy");
    }
    ImageClass.setImage(images.v7.V7JoeyGym_2);
    mc.talk(`Hey Joey.`);
    ImageClass.setImage(images.v7.V7JoeyGym_3);
    joe.talk(`${mc.name}, my man!`);
    if (mc.properties.v7WentWithJennyDate) {

    } else {
        joe.talk(`I was hoping you'd come!`);

    }
    ImageClass.setImage(images.v7.V7JoeyGym_4, { duration: 1 });
    joe.talk(`Come here, do some sets before we start.`);
    mc.talk(`Sure, why not.`);
    ImageClass.setImage(images.v7.V7JoeyGym_5, { duration: 1 });
    joe.talk(`Feel your mussels work!`);
    ImageClass.setImage(images.v7.V7JoeyGym_6);

    joe.talk(`Damn, you are stronger than I thought.`);
    ImageClass.setImage(images.v7.V7JoeyGym_5,);

    joe.talk(`I put on some extra weight because I'm here to watch over you, but damn, I'm barely touching it.`);
    ImageClass.setImage(images.v7.V7JoeyGym_6);
    mc.talk(`I'm not a pussy like you!`);
    ImageClass.setImage(images.v7.V7JoeyGym_5,);
    joe.talk(`Hey! Haha.`);
    ImageClass.setImage(images.v7.V7JoeyGym_6);
    mc.talk(`Haha.`);

    ImageClass.setImage(images.v7.V7JoeyGym_5,);
    joe.talk(`And... Set.`);
    ImageClass.setImage(images.v7.V7JoeyGym_4);
    joe.talk(`How does it feel?`);
    mc.talk(`It feels great actually.`);
    joe.talk(`I know! I love it when I feel the blood running through my veins.`);

    mc.talk(`I might come by more often.`);
    joe.talk(`Finally! That's what I wanted to hear!`);
    joe.talk(`If I only knew that all I needed was to ask you to lift some weight.`);
    joe.talk(`Come on, let's chat for a bit.`);

    return jump(V7JoeGym2, "V7JoeGym2");
};
export const V7JoeGym2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7JoeyGym_7);
    if (mc.properties.v7WentWithJennyDate) {
        joe.talk(`First thing first.`);
        joe.talk(`How was your date with what's her name?`);
        ImageClass.setImage(images.v7.V7JoeyGym_8);
        mc.talk(`Jenny?`);
        ImageClass.setImage(images.v7.V7JoeyGym_10);
        joe.talk(`Yeah! Her!`);
        mc.talk(`One thing I gotta say about her.`);
        mc.talk(`She talks a lot!`);
        if (Question.globalAnswers.v7JennyDateKeptListening) {
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I listened to her every word but damn.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`Usually girls talk when they are nervous.`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`You think?`);
            ImageClass.setImage(images.v7.V7JoeyGym_10);
            joe.talk(`I would've if I was going out with a stud like you!`);
            joe.talk(`No homo!`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Haha.`);

        } else {
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`At one point I actually drifted away while she started talking about her brothers or something.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`You remember that she has brothers so you did your part.`);
            joe.talk(`Did you just nod and agreed?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I did.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`That's all you need! Haha.`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Haha, I guess.`);
        }
        ImageClass.setImage(images.v7.V7JoeyGym_7);
        joe.talk(`WELL?`);
        ImageClass.setImage(images.v7.V7JoeyGym_8);
        mc.talk(`What?`);
        ImageClass.setImage(images.v7.V7JoeyGym_10);
        joe.talk(`Come on! Give me something, did you fuck???`);
        ImageClass.setImage(images.v7.V7JoeyGym_8);
        mc.talk(`She's not that kind of girl.`);
        ImageClass.setImage(images.v7.V7JoeyGym_7);
        joe.talk(`Damn... But it shows class!`);
        if (Question.globalAnswers.v7JennyDateKissedHer) {
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`We did kiss...`);
            if (Question.globalAnswers.v7JennyDateTriedToGoFurther) {
                ImageClass.setImage(images.v7.V7JoeyGym_8);
                mc.talk(`I tried to take it one step further but she wasn't ready.`);

            } else {
                ImageClass.setImage(images.v7.V7JoeyGym_7);
                joe.talk(`Liked I said. Class.`);
                joe.talk(`But it's good bro! She kissed you back, it shows that she is interested.`);

            }
        } else {
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`We had that tension silence for a minute in the car.`);
            mc.talk(`I guess I should have kissed her, but I hesitated.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`Yeah you should've.`);
            joe.talk(`But it's not over! Now she thinks that you are not looking for a one night stand. That's good!`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Yeah I guess.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`Did she hint for a second date?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Yes.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`So you are all good!`);
            joe.talk(`Just kiss her next time, okie?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Haha. I will.`);
        }

        ImageClass.setImage(images.v7.V7JoeyGym_7);
        if (mc.properties.annStatus === "gf") {
            joe.talk(`Is that a bye-bye to Ann?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I haven't decided.`);
            mc.talk(`Do I have to choose?`);
            ImageClass.setImage(images.v7.V7JoeyGym_10);
            joe.talk(`Of course not Grasshopper! The more the merrier right?`);
        }
        if (mc.properties.alexRelationship > 0) {
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            if (mc.properties.annStatus === "gf") {
                mc.talk(`I guess it's a good time to mention my new neighbor?`);
            } else {
                mc.talk(`Besides her, there might be a new girl in the picture.`);
                ImageClass.setImage(images.v7.V7JoeyGym_7);
                joe.talk(`Who?`);
                ImageClass.setImage(images.v7.V7JoeyGym_8);
                mc.talk(`My new neighbor.`);
            }

            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`New neighbor?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Yes, Alex. I've known her from Insta, she is also a friend of Ann's.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            if (mc.properties.annStatus === "gf") {
                joe.talk(`Damn, that's dangerous.`);

            } else {
                joe.talk(`Damn, I hope she won't trash talk you to her.`);
                ImageClass.setImage(images.v7.V7JoeyGym_8);
                mc.talk(`I don't think she's that kind of girl.`);
                ImageClass.setImage(images.v7.V7JoeyGym_7);
                joe.talk(`You may never know my friend...until it is too late.`);
            }

            joe.talk(`Are you also dating her?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Not yet! Haha.`);
            mc.talk(`I'll tell you more about her some other time.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`I'll take a rain check on that one for sure!`);

        } else {

        }
        ImageClass.setImage(images.v7.V7JoeyGym_8);
        mc.talk(`Right, haha.`);
        if (mc.properties.annStatus === "gf") {
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`Don't worry, I won't say a word.`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I didn't think you would.`);

        } else {
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`Don't worry if you want to date both, I won't say a word.`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I didn't think you would.`);

        }


    } else {

    }

    if (Question.globalAnswers.v1JoePresentIdea === "sextape") {
        return jump(JoeGym_SexTapeConversation, "JoeGym_SexTapeConversation");

    }
    return jump(V7JoeGymVanessaConversation, "V7JoeGymVanessaConversation");
};

export const JoeGym_SexTapeConversation = async (): Promise<any> => {
    if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
        // TODO: filmed sextape 

    } else {
        if (Question.globalAnswers.v4SexTapeAgreeToFilm === false) {
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`So remember when it was my birthday and I asked you to film me with Vanessa?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Sorry about refusing to film you guys, I hope it all worked out in the end.`);
            // TODO: if tricked Joe, maybe add alternative scene
            ImageClass.setImage(images.v7.V7JoeyGym_10);
            joe.talk(`It would've been better if we had someone to film us.`);
            joe.talk(`But it turned out really great in the end!`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I'm glad to hear that.`);
        } else {
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`So, do you remember my birthday?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I do.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`So that day we went home and we went wild!`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            mc.talk(`Well... You are a couple and it was your birthday.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`Yeah... But it was different.`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Different how?`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`We actually filmed a sex tape!`);
        }


        ImageClass.setImage(images.v7.V7JoeyGym_10);
        joe.talk(`Wanna see?`);
        ImageClass.setImage(images.v7.V7JoeyGym_8);
        mc.talk(`What? The sex tape?`);
        ImageClass.setImage(images.v7.V7JoeyGym_7);
        joe.talk(`Yeah!`);
        ImageClass.setImage(images.v7.V7JoeyGym_8);
        mc.talk(`Are you inviting me to see you dick?`);
        if (Game.seenScenarios.includes(`V6Underpass`)) {
            ImageClass.setImage(images.v7.V7JoeyGym_10);
            joe.talk(`It's not like you've never seen it before.`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`True, but now I can control it.`);

        } else {

        }
        ImageClass.setImage(images.v7.V7JoeyGym_10);
        joe.talk(`I just wanted you to see the action man! You don't have to look at my dick!`);
        ImageClass.setImage(images.v7.V7JoeyGym_11);

        await joe.setQuestion(new Question({ text: `So, what do you say?`, options: { think: false }, key: `v7JoeGymSawSexTape` })
            .option({ title: `Agree`, key: true })
            .option({ title: `Refuse`, key: false }));


        if (Question.globalAnswers.v7JoeGymSawSexTape) {
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`Alright, let me see.`);

            await Phone.showMessagesUI({ name: `my little devil`, profileImage: othersProfilesPics.vanessaProfilePic, wallpaper: othersProfilesPics.vanessaWallpaper }, async () => {
                Phone.setMessage({ character: vanessa.character, text: `Honey, I took some screenshots of our naughty tape.`, options: { wait: false } });
                Phone.setMessage({ character: vanessa.character, text: `Don't masturbate too hard 😈🍆`, options: { wait: false } });

                Phone.setImage({ ...images.v7.SexTapeNoMC_10, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_11, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_12, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_13, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_4, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_3, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_5, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_6, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_14, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_15, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_16, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_17, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_18, character: vanessa.character, options: { wait: false } });
                Phone.setImage({ ...images.v7.SexTapeNoMC_19, character: vanessa.character, options: { wait: false } });
                Phone.setMessage({ character: mc.character, text: `FUCK ITS SO HOT WE GOTTA DO IT AGAIN SOON`, options: { wait: false } });
                Phone.setMessage({ character: vanessa.character, text: `caps`, options: { wait: false } });


                Phone.closeMessagesUI();
            });

            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`So? What do you think?`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`I still can't wrap my head around the fact that Vanessa don't mind being filmed.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`Really bro?`);
            joe.talk(`You should know her by now.`);
            joe.talk(`She'll take every opportunity to get naked, and the more people that see her naked the better for her.`);
            ImageClass.setImage(images.v7.V7JoeyGym_8);
            mc.talk(`You are right, I don't know what I was saying.`);
        } else {
            mc.talk(`No man, I'll give it a pass.`);
            ImageClass.setImage(images.v7.V7JoeyGym_7);
            joe.talk(`No worries bro, let me know if you change your mind.`);
        }
    }

    return jump(V7JoeGymVanessaConversation, "V7JoeGymVanessaConversation");
};

export const V7JoeGymVanessaConversation = async (): Promise<any> => {
    doWaitImageByTime(images.v7.V7JoeyGym_14);
    if (Question.globalAnswers.v7JoeGymSawSexTape) {
        joe.talk(`Since we are already talking about her, can I tell you something?`);

    } else {
        joe.talk(`Can I tell you something?`);

    }
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`Of course.`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`But please, keep it between us.`);
    mc.talk(`Of course! You don't even have to say that.`);
    if (Question.globalAnswers.v7JoeGymSawSexTape) {

    } else {
        joe.talk(`It's about Vanessa...`);


    }
    joe.talk(`Do you remember when I came over after we made our little comeback?`);
    joe.talk(`Do you remember how happy and excited I was talking about her?`);
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`Yes...`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`It all changed...`);
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`You mentioned something in the past... You said that you knew what she was like and that you were kinda trying to keep up.`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`I know. I thought that if I just tried to "compete" with her, everything would be fine.`);
    ImageClass.setImage(images.v7.V7JoeyGym_12, { duration: 1 });
    joe.talk(`I was wrong.`);
    joe.talk(`Even though I enjoy chasing after girls all day, it requires work.\nSometimes I just want to sit back and enjoy a healthy relationship with my girl.`);
    joe.talk(`But this isn't working.`);
    joe.talk(`I've tried talking to her...`);


    if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "dontHurtJoey") {
        ImageClass.setImage(images.v7.V7JoeyGym_14, { duration: 1 });
        joe.talk(`I also know you tried to get her to stop... She'd told me you asked her to stop hurting me.`);
        joe.talk(`You are a good friend ${mc.name}.`);
    } else {

    }
    mc.talk(`Wow.`);
    ImageClass.setImage(images.v7.V7JoeyGym_12);
    mc.talk(`You are talking like you want to break-up.`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`I don't see any other choice.`);
    joe.talk(`Every time we meet I can't help but think what she did before meeting me.`);
    ImageClass.setImage(images.v7.V7JoeyGym_12);
    joe.talk(`You see? I'm not the jealous type, but when you know someone is doing stuff behind your back. You become one.`);
    joe.talk(`And for some reason she doesn't care if I'm doing the same...`);
    if (Question.globalAnswers.v7JoeGymSawSexTape === undefined) {

    } else {
        if (Question.globalAnswers.v7JoeGymSawSexTape) {
            mc.talk(`It's so weird, you were just so excited to show me the sex tape.`);

        } else {
            mc.talk(`It's so weird, you just offered me to show the sex tape.`);

        }
        joe.talk(`It was just me holding on to the last thread of our relationship.`);

    }

    joe.talk(`I might be mistaken, but some people would die to be with Vanessa...`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`With her you can experience things that you can only dream of.`);
    joe.talk(`But I might be done.`);

    ImageClass.setImage(images.v7.V7JoeyGym_13);
    if (mc.properties.vanessaRelationship > 10) {
        mc.talk(`It seems like you made up your mind.`);

    } else {
        mc.talk(`Have you thought this through?`);
    }
    joe.talk(`I have.`);
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v7.V7JoeyGym_15);
        joe.talk(`You are so lucky to have Ann.`);
        if (ann.properties.isCorrupted) {
            joe.talk(`Even though you are changing her to be just like Vanessa.`);
            ImageClass.setImage(images.v7.V7JoeyGym_13);
            mc.talk(`It wasn't fully me, it was something hidden inside her.\nI just encouraged her to embrace it.`);
            ImageClass.setImage(images.v7.V7JoeyGym_14);
            joe.talk(`Yeah, I guess.`);
            joe.talk(`Sorry. But can't we just talk about her some other time... My mind is all over the place right now.`);
            mc.talk(`Sure, I get it.`);

        } else {

        }

    } else {

    }
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`I can only imagine what a healthy relationship is like...`);
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`You said you've been with other girls besides Vanessa.`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`Everything I've told you is true, but having sex with someone is not a relationship.`);
    joe.talk(`It was really exciting at first. You know, after I lost my weight.`);
    ImageClass.setImage(images.v7.V7JoeyGym_15);
    joe.talk(`But it became boring really fast.`);
    joe.talk(`Don't get me wrong. It's always exciting to hook up with a new girl.`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`But the next day it feels empty.`);
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`Why didn't you try to be with one of those girls you are talking about?`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`I already gave them the vibe I'm not interested in a long-term relationship.`);
    joe.talk(`I did it with Vanessa as well, but I got sucked into her vortex.`);
    mc.think(`She tends to do that to people.`);
    ImageClass.setImage(images.v7.V7JoeyGym_12);
    await joe.setQuestion(new Question({ text: `I guess I'll talk to her soon.`, options: { think: false }, key: `v7JoeGymToldBreakupVanessa` })
        .option({ title: `Encourage him to breakup with Vanessa`, key: true })
        .option({ title: `Encourage him to stay with Vanessa`, key: false }));


    if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
        mc.talk(`For what it's worth, it sounds like the right choice.`);
        ImageClass.setImage(images.v7.V7JoeyGym_13);
        mc.talk(`She is not healthy for you and she is clearly affecting your mood.`);

    } else {
        mc.talk(`I don't know man... Maybe you should try to salvage it.`);
        ImageClass.setImage(images.v7.V7JoeyGym_13);
        mc.talk(`This clearly shows that you care for her, even love her...`);
        mc.talk(`If you ask me, don't rush into doing something you might regret.`);
    }
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`I appreciate your honesty.`);
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`I'm always here for you Joe.`);

    ImageClass.setImage(images.v7.V7JoeyGym_15);
    joe.talk(`Hey you called me Joe!`);
    mc.talk(`Haha, it got you to smile.`);
    joe.talk(`Thanks bro.`);

    return jump(V7JoeGymAfter, "V7JoeGymAfter");
};

export const V7JoeGym_Enemy = async (): Promise<any> => {
    doWaitImageByTime(images.v7.V7JoeyGym_2);
    mc.talk(`Joey...`);
    ImageClass.setImage(images.v7.V7JoeyGym_17);
    joe.talk(`${mc.name}! I'm so glad you came!`);
    doWaitImageByTime(images.v7.V7JoeyGym_12);
    joe.talk(`So...`);
    joe.talk(`There are a lot of things I'd like to say, but it's hard to decide where to start...`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    joe.talk(`So... Lately I've been thinking that I'm not happy with how our situation is.`);
    joe.talk(`I'd like to believe you feel the same since you are here.`);
    joe.talk(`Remember how we always said: "Bros before hoes"?`);
    joe.talk(`I think it's time for us to stand behind that sentence...`);
    joe.talk(`I'm having a really hard time lately.`);
    joe.talk(`My relationship with Vanessa is going to the shitter and I need a friend... My best friend again.`);

    if (Question.globalAnswers.v1EnableNTR) {
        ImageClass.setImage(images.v7.V7JoeyGym_13);
        mc.talk(`Before you continue there is something I gotta ask.`);
        ImageClass.setImage(images.v7.V7JoeyGym_14);
        joe.talk(`Sure.`);
        ImageClass.setImage(images.v7.V7JoeyGym_13);
        mc.talk(`What's going on with you and Emily? I know you met with her.`);
        ImageClass.setImage(images.v7.V7JoeyGym_14);
        joe.talk(`About that...`);
        joe.talk(`I was really down the other day... I lay in my bed and really needed someone to talk to.`);
        joe.talk(`At one point I picked up my phone and typed your name...`);
        ImageClass.setImage(images.v7.V7JoeyGym_13);
        joe.talk(`But then Emily's name popped up because she's written as ${mc.name}'s ${emily.properties.relation}...`);
        joe.talk(`I don't know what I was thinking and gave her a call.`);
        joe.talk(`She was surprised I called, but also glad to hear from me because she knew something was going on.`);
        joe.talk(`She's still used to see me at your place every day...`);
        ImageClass.setImage(images.v7.V7JoeyGym_14);
        joe.talk(`And she could feel like I'm in a bad mood...`);
        joe.talk(`We kept talking for a bit and somehow we both agreed it would be better if we talk in person.`);
        joe.talk(`So we met. She gave me some good advices and that's it.`);

        ImageClass.setImage(images.v7.V7JoeyGym_13);
        mc.talk(`Is that it?`);
        ImageClass.setImage(images.v7.V7JoeyGym_14);
        joe.talk(`That's it.`);
        ImageClass.setImage(images.v7.V7JoeyGym_13);
        mc.talk(`But I've seen you too, she was way over dressed to just meet and talk.`);
        ImageClass.setImage(images.v7.V7JoeyGym_14);
        joe.talk(`Oh yeah...`);
        joe.talk(`She said she has a dress she's dying to show off and she didn't have an opportunity yet.`);
        joe.talk(`So I just told her she can put it on. That's it.`);

        if (Question.globalAnswers.v6EmilyAfterJoeRivalConvAllowDatingJoe) {
            mc.talk(`You know... For what's it worth, I've talk to Emily about that already.`);
            mc.talk(`And I think that it might be a good idea if both of you started dating.`);
            ImageClass.setImage(images.v7.V7JoeyGym_20);
            joe.talk(`Wow... Are you serious?`);
            ImageClass.setImage(images.v7.V7JoeyGym_13);
            mc.talk(`Sure... Why not?`);
            ImageClass.setImage(images.v7.V7JoeyGym_20);
            joe.talk(`Damn... What did she say?`);
            mc.talk(`That she'll think about that.`);
            mc.talk(`You can't hide it. I know you like her.`);
            ImageClass.setImage(images.v7.V7JoeyGym_14);
            joe.talk(`Wow...`);
            mc.talk(`Good luck bro.`);
            ImageClass.setImage(images.v7.V7JoeyGym_15);
            joe.talk(`Thanks man!`);


        } else {
            mc.think(`I don't think he is lying... Both their stories line up.`);
            mc.talk(`I believe you.`);
            joe.talk(`Thanks man.`);

        }


    } else {

    }
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`I guess that now it's my turn.`);
    mc.talk(`I'll start with saying what I did with Vanessa wasn't cool at all...`);
    ImageClass.setImage(images.v7.V7JoeyGym_15);
    joe.talk(`That's what I get for dating a hoe right...? Ha...`);
    ImageClass.setImage(images.v7.V7JoeyGym_13);
    mc.talk(`Either way, I shouldn't have betrayed you like that.`);
    mc.talk(`You trusted me and I fucked up.`);

    if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor) {
        ImageClass.setImage(images.v7.V7JoeyGym_14);
        joe.talk(`I'm sorry I did what I did with Ann as well...`);
        joe.talk(`I don't know how Vanessa managed to sell it to me.`);
        joe.talk(`Looking back it was really fucked up.`);
        // TODO: Write Ann's perspective and come back to this.
        joe.talk(`I'm glad Ann was okay with that.`);

    } else {

    }
    if (Question.globalAnswers.v7JoeRivalOfferJennyRide) {
        mc.talk(`And if we are starting with a clean slate...`);
        mc.talk(`I offered that girl you were dating a ride and I kinda gave her my number.`);
        ImageClass.setImage(images.v7.V7JoeyGym_15);
        joe.talk(`Bro... I don't care about her one bit.`);
        joe.talk(`She kept blue balling me... You can do whatever you want with her.`);
    }

    mc.talk(`So... You and Vanessa are no more?`);
    ImageClass.setImage(images.v7.V7JoeyGym_14);
    await joe.setQuestion(new Question({ text: `I'm not sure... But it seems like it.`, options: { think: false }, key: `v7JoeGymToldBreakupVanessa` })
        .option({ title: `Encourage him to breakup with Vanessa`, key: true })
        .option({ title: `Encourage him to stay with Vanessa`, key: false }));
    if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
        mc.talk(`For what it's worth, I think you sure try and salvage it and stay together.`);
        ImageClass.setImage(images.v7.V7JoeyGym_12);
        joe.talk(`Yeah... Maybe... We'll see.`);

    } else {
        mc.talk(`It think the best move for you right now is to break out with her.`);
        mc.talk(`I honestly think your relationship is toxic.`);
        ImageClass.setImage(images.v7.V7JoeyGym_12);
        joe.talk(`Yeah... I can see what your are saying.`);

    }
    joe.talk(`Anyway...`);
    ImageClass.setImage(images.v7.V7JoeyGym_18);
    joe.talk(`Are we good?`);
    ImageClass.setImage(images.v7.V7JoeyGym_19);
    mc.talk(`Yes man.`);

    await mc.set((properties) => {
        properties.joeStatus = "friend";
    });
    return jump(V7JoeGymAfter, "V7JoeGymAfter");
};